const setCircleBlur = (state, circleBlur) => {
  state.draft.colorStyle.paint.circleBlur = circleBlur
}
const setCustomColor = async (state, payload) => {
  if (Array.isArray(payload.color)) {
    state.draft.colorStyle.custom.colors = payload.color
    state.draft.colorStyle.custom.groupName = payload.groupName
    state.draft.colorStyle.custom.schemeType = payload.selectedSchemeType
    if (parseFloat(state.draft.colorStyle.paint.fillOpacity) <= 0) {
      state.draft.colorStyle.paint.fillOpacity = 1
      // this.onBlurChange()
    }
  }
}
const setCompositeStyle = async (state, style) => {

}
const setFillColor = (state, color) => {
  state.draft.colorStyle.paint.fillColor = state.draft.symbolStyle.paint.iconColor = color
  state.draft.colorStyle.custom.color = color
}
const setFillOpacity = (state, opacity) => {
  state.draft.colorStyle.paint.fillOpacity = state.draft.symbolStyle.paint.iconOpacity = opacity
}
const setMarkerColor = (state, color) => {
  state.markerStyle.iconColor = color
}
const setMarkerIcon = (state, icon) => {
  state.markerStyle.iconImage = icon
}
const setMarkerSize = (state, size) => {
  state.markerStyle.iconSize = size
}
const syncBorderStyle = (state, style) => {
  state.draft.borderStyle.paint.borderColor = style.paint.hasOwnProperty('line-color') ? style.paint['line-color'] : state.draft.borderStyle.paint.borderColor
  state.draft.borderStyle.paint.borderOpacity = style.paint.hasOwnProperty('line-opacity') ? parseFloat(style.paint['line-opacity']) : state.draft.borderStyle.paint.borderOpacity
  state.draft.borderStyle.paint.borderWidth = style.paint.hasOwnProperty('line-width') ? parseFloat(style.paint['line-width']) : state.draft.borderStyle.paint.borderWidth
}
const syncColorStyle = (state, {layerType, style}) => {
  switch (layerType) {
    case 'circle':
    case 'cluster':
      state.draft.sizeStyle.paint.circleRadius = parseInt(style.paint['circle-radius'])
      // self.sizeSliderOptions.value = self.sizeStyle.paint.circleRadius
      state.draft.colorStyle.paint.fillColor = style.paint.hasOwnProperty('circle-color') ? style.paint['circle-color'] : state.draft.colorStyle.paint.fillColor
      state.draft.symbolStyle.paint.iconColor = state.draft.colorStyle.paint.fillColor
      state.draft.colorStyle.paint.circleBlur = style.paint.hasOwnProperty('circle-blur') ? parseFloat(style.paint['circle-blur']) : state.draft.colorStyle.paint.circleBlur
      state.draft.colorStyle.paint.fillOpacity = style.paint.hasOwnProperty('circle-opacity') ? parseFloat(style.paint['circle-opacity']) : state.draft.colorStyle.paint.fillOpacity
      state.draft.borderStyle.paint.borderColor = style.paint['circle-stroke-color'] || state.draft.borderStyle.paint.borderColor
      state.draft.borderStyle.paint.borderOpacity = parseFloat(style.paint['circle-stroke-opacity']) || parseFloat(state.draft.borderStyle.paint.borderOpacity)
      state.draft.borderStyle.paint.borderWidth = parseFloat(style.paint['circle-stroke-width']) || state.draft.borderStyle.paint.borderWidth
      state.draft.colorStyle.custom = style.hasOwnProperty('custom') && style.custom['color'] !== null && typeof style.custom['color'] !== 'undefined' ? style.custom['color'] : state.draft.colorStyle.custom
      state.draft.sizeStyle.custom = style.hasOwnProperty('custom') && style.custom['size'] !== null && typeof style.custom['size'] !== 'undefined' ? style.custom['size'] : state.draft.sizeStyle.custom
      state.draft.colorStyle.custom.color = style.paint['circle-color']
      // if (state.draft.sizeStyle.custom.expressionId !== 0 && !state.draft.visitedCards.includes('size')) state.draft.visitedCards.push('size')
      break
    case 'hexagon':
    case 'fill':
      state.draft.colorStyle.custom = style.hasOwnProperty('custom') &&  style.custom.hasOwnProperty('color') && style.custom['color'] !== null && typeof style.custom['color'] !== 'undefined' ? style.custom['color'] : state.draft.colorStyle.custom
      state.draft.colorStyle.paint.fillOpacity = style.paint.hasOwnProperty('fill-opacity') ? style.paint['fill-opacity'] : state.draft.colorStyle.paint.fillOpacity
      state.draft.colorStyle.paint.fillColor = style.paint.hasOwnProperty('fill-color') ? style.paint['fill-color'] : state.draft.colorStyle.paint.fillColor
      state.draft.colorStyle.custom.color = (!Array.isArray(state.draft.colorStyle.paint.fillColor)) ? state.draft.colorStyle.paint.fillColor : (!Array.isArray(style.paint['fill-color'])) ? style.paint['fill-color'] : state.draft.colorStyle.custom.color
      // Fix :: Transparência do polígono no modo hexágonos (Ferraz)
      // if (self.featureLayer.IsHexagon && !self.featureLayer.IsAutoModeSystem && state.draft.colorStyle.paint.fillColor === 'rgba(0,0,0,0)') {
      //   state.draft.colorStyle.paint.fillColor = 'rgba(0,0,0,0.6)'
      // }
      break
    case 'label':
      break
    case 'line':
      state.draft.colorStyle.paint.fillColor = style.paint.hasOwnProperty('line-color') ? style.paint['line-color'] : state.draft.colorStyle.paint.fillColor
      state.draft.colorStyle.paint.circleBlur = style.paint.hasOwnProperty('line-blur') ? parseFloat(style.paint['line-blur']) : state.draft.colorStyle.paint.circleBlur
      state.draft.colorStyle.paint.fillOpacity = style.paint.hasOwnProperty('line-opacity') ? style.paint['line-opacity'] : state.draft.colorStyle.paint.fillOpacity
      // Definindo o circleRadius com base no valor de lineWidth
      state.draft.colorStyle.custom = style.hasOwnProperty('custom') && style.custom['color'] !== null && typeof style.custom['color'] !== 'undefined' ? style.custom['color'] : state.draft.colorStyle.custom
      state.draft.sizeStyle.custom = style.hasOwnProperty('custom') && style.custom['size'] !== null && typeof style.custom['size'] !== 'undefined' ? style.custom['size'] : state.draft.sizeStyle.custom
      // self.colorStyle.custom.color = (!Array.isArray(self.colorStyle.paint.fillColor)) ? self.colorStyle.paint.fillColor : (!Array.isArray(style.paint['line-color'])) ? style.paint['line-color'] : self.colorStyle.custom.color
      // self.symbolStyle.paint.iconColor = (self.colorStyle.custom.colors !== undefined && self.colorStyle.custom.colors.length !== 0) ? self.colorStyle.custom.colors[0] : self.colorStyle.paint.fillColor
      state.draft.colorStyle.custom.color = (!Array.isArray(state.draft.colorStyle.paint.fillColor)) ? state.draft.colorStyle.paint.fillColor : (!Array.isArray(style.paint['line-color'])) ? style.paint['line-color'] : state.draft.colorStyle.custom.color
      // state.draft.sizeStyle.paint.circleRadius = self.getLineValue(style.paint['line-width']);
      // state.draft.sizeSliderOptions.value = state.draft.sizeStyle.paint.circleRadius
      // if (state.draft.sizeStyle.custom.expressionId !== 0 && !self.visitedCards.includes('size')) self.visitedCards.push('size')
      break
    case 'symbol':
      break
  }
}

export default {
  setCircleBlur,
  setCompositeStyle,
  setCustomColor,
  setFillColor,
  setFillOpacity,
  setMarkerColor,
  setMarkerIcon,
  setMarkerSize,
  syncBorderStyle,
  syncColorStyle
}
